import { render, staticRenderFns } from "./EmailTokenLoginForm.vue?vue&type=template&id=baa63f14&scoped=true&"
import script from "./EmailTokenLoginForm.vue?vue&type=script&lang=js&"
export * from "./EmailTokenLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailTokenLoginForm.vue?vue&type=style&index=0&id=baa63f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa63f14",
  null
  
)

export default component.exports